<template>
    <div class="has-text-centered p-t-lg">
        <transition name="component-fade" mode="out-in">
            <component :is="formView"
                       @login="showLogin"
                       @loggedIn="redirect"
                       @forgetPassword="showForgetPassword"
                       @register="showRegister"
            >
            </component>
        </transition>
    </div>
</template>

<script>
    import RegisterForm from '../../components/connection/RegisterForm'
    import SignInForm from '../../components/connection/SignInForm.vue'
    import ForgetPasswordForm from '../../components/connection/ForgetPasswordForm.vue'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            RegisterForm,
            SignInForm,
            ForgetPasswordForm
        },
        data () {
            return {
                formView: SignInForm,
                login: true,
                register: false,
                forgetPassword: false
            }
        },
        methods: {
            isCandidate () {
                return this.userRoles && this.userRoles.indexOf('candidate') > -1
            },
            isAdmin () {
                return this.userRoles && this.userRoles.indexOf('admin') > -1
            },
            redirect: function () {
                this.$scrollTo('.app-container', { offset: -10 }, 200)

                this.loggedUser()
            },
            showRegister: function () {
                this.formView = RegisterForm
            },
            showLogin: function () {
                this.formView = SignInForm
            },
            showForgetPassword: function () {
                this.formView = ForgetPasswordForm
            },
            loggedUser: function () {
                if (this.isLoggedIn && this.isCandidate()) {
                    this.$router.push({ name:'highschool-categories' })
                }
                if (this.isLoggedIn && this.isAdmin()) {
                    this.$router.push({ path: '/admin' })
                }
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'auth/isLoggedIn',
                userRoles: 'auth/getRoles'
            })
        },
        beforeMount () {
            this.loggedUser()
        }
    }
</script>
